import { createContext, useContext, useState, useEffect } from 'react'

/**
 * Context global de l'application
 * Gère les préférences utilisateur, l'état global, etc.
 */
const AppContext = createContext()

export const useAppContext = () => {
  const context = useContext(AppContext)
  if (!context) {
    throw new Error('useAppContext must be used within AppProvider')
  }
  return context
}

export const AppProvider = ({ children }) => {
  // État global
  const [user, setUser] = useState(null)

  // Initialiser les préférences depuis localStorage avec lazy initialization
  const [preferences, setPreferences] = useState(() => {
    try {
      const savedPreferences = localStorage.getItem('userPreferences')
      if (savedPreferences) {
        return JSON.parse(savedPreferences)
      }
    } catch (error) {
      console.error('Error loading preferences:', error)
    }
    return {
      cookiesAccepted: false,
      newsletterSubscribed: false
    }
  })

  // Sauvegarder les préférences dans localStorage
  useEffect(() => {
    localStorage.setItem('userPreferences', JSON.stringify(preferences))
  }, [preferences])

  // Fonction pour accepter les cookies
  const acceptCookies = () => {
    setPreferences(prev => ({ ...prev, cookiesAccepted: true }))
  }

  // Fonction pour s'abonner à la newsletter
  const subscribeNewsletter = (_email) => {
    setPreferences(prev => ({ ...prev, newsletterSubscribed: true }))
    // TODO: Implémenter l'appel API pour l'inscription newsletter
  }

  const value = {
    user,
    setUser,
    preferences,
    setPreferences,
    acceptCookies,
    subscribeNewsletter
  }

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}

export default AppContext
